import axios from 'axios';
import { Notification } from '../features/Notifications/Notifications.interfaces';
import { RESTSERVICES_BASE_URL } from './constants';

export interface NotificationResponse {
  unread: number;
  notifications: Notification[];
}

export const getPortalNotificationsService = (portalNotifications?: boolean) =>
  axios
    .get<NotificationResponse>(
      `${RESTSERVICES_BASE_URL}/user-notifications`,
      // TODO: Uncomment this line to enable the featured notifications
      // { params: { featured: portalNotifications ? undefined : true },}
    )
    .then((response) => response.data);

export const readPortalNotificationsService = (notificationIds: string[]) =>
  axios.post(`${RESTSERVICES_BASE_URL}/user-notifications/mark-read`, {
    notificationIds,
  });
